export default __webpack_public_path__ + "75b2dc578d4672b9ce674c6fd210860b.svg";